import { useState } from 'react';
import { Tooltip } from '@mui/material';
import { SimpleDialog, CommonTooltip, Icons } from 'components';
import { useStyles } from './style';

export default function LabelWithToolTip({
  label = '',
  description,
  showInDialog = false,
}) {
  const classes = useStyles();
  const [isOpenDialog, setIsOpenDialog] = useState(false);
  const openDialog = () => setIsOpenDialog(true);
  const closeDialog = () => setIsOpenDialog(false);
  if (!description) return label ?? '';
  if (!showInDialog)
    return (
      <div className={classes.root}>
        {label}{' '}
        <CommonTooltip title={description}>
          <span className={classes.icon} >
            <Icons icon='Info' color='#303d8f' hover='#667585' size='18' />
          </span>
        </CommonTooltip>
      </div>
    );
  return (
    <div className={classes.root}>
      {label}{' '}
      <Tooltip title={label} className={classes.clickable} onClick={openDialog}>
        <span className={classes.icon} >
          <Icons icon='Info' color='#303d8f' hover='#667585' size='18' />
        </span>

      </Tooltip>
      <SimpleDialog title={label} open={isOpenDialog} onClose={closeDialog} content={description} />
    </div>
  );
}


